import { render } from "./OfficeLoader.vue?vue&type=template&id=a47fde28"
import script from "./OfficeLoader.vue?vue&type=script&lang=js"
export * from "./OfficeLoader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/declic-center-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__